import Vue from 'vue';
import { getParams } from '@eyunmy/bridge';
import FastClick from 'fastclick';
// import Vconsole from 'vconsole';
import App from './App.vue';
import store from './store';
import router from './router';
import util from './lib/index';
// import '@/assets/css/loveshow-ui.css';
// import '@/assets/css/loveshow.css';
// import '@/assets/css/style.css';
// import '@/assets/css/company.css';
import '@/assets/css/loveshow_9870ce2.css';

const BrowserLogger = require('alife-logger');
// require('./mock');

// if (util.isTest) {
//   let vcons = new Vconsole(); // eslint-disable-line no-unused-vars
// }

if (!util.isTest) {
  // eslint-disable-next-line
  window.__bl = BrowserLogger.singleton({
    pid: 'dp5p0pay1c@daa49d1f1ca5941',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    behavior: true,
    tag: '可心交友官方网站',
    ignore: {
      ignoreErrors: /^Script error\.?$/,
    },
  });
}

Vue.config.productionTip = false;
Vue.prototype.util = util;
FastClick.attach(document.body);

const vueInstance = () => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
};

getParams().then(({ uid, token }) => store.commit('setState', { uid, token }))
  .then(vueInstance).catch(vueInstance);
